import RipianiTable from './RipianiTable';
export default RipianiTable;